import { fetchData } from "app/services/apiService";

export const caricaAccettazioniByAnagrafica = (
  idAnagrafica,
  dataAccettazione
) => {
  if (!dataAccettazione) {
    dataAccettazione = "''";
  }

  const payload = {
    IDAnagrafica: idAnagrafica,
    dataAccettazione: dataAccettazione,
  };
  const apiUrl = "Accettazione/GetAccettazioni";

  return (dispatch) => {
    return dispatch(fetchData(apiUrl, payload))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
};

export const caricaAccettazioniNre = (dataAccettazione) => {
  const payload = {
    dataAccettazione: dataAccettazione,
  };
  const apiUrl = "Accettazione/GetAccettazioniNre";

  return (dispatch) => {
    return dispatch(fetchData(apiUrl, payload))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
};

export const caricaFattureByIDAccettazione = (idAccettazione) => {
  const payload = {
    IDAccettazione: idAccettazione,
  };
  const apiUrl = "Fatture/elencoFattureByAccettazione";

  return (dispatch) => {
    return dispatch(fetchData(apiUrl, payload))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
};

export const cancellaAccettazioneLogica = (idAccettazione) => {
  const payload = {
    IDAccettazione: idAccettazione,
  };
  const apiUrl = "Accettazione/Cancella";

  return (dispatch) => {
    return dispatch(fetchData(apiUrl, payload))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
};
